import GameModel from "./GameModel";
import Config from "../../../../../../shared/src/ranj/app/config/Config";
import NGTScenarioPlayer from "../../ngt/scenario/NGTScenarioPlayer";
import NGTVariableManager from "../../ngt/base/NGTVariableManager";
import ScenarioLibrary from "../../ngt/scenario/ScenarioLibrary";
import { isNull } from "../../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import BaseSaveModel from "../../../../../../shared/src/ranj/equalture/savegame/BaseSaveModel";

export default class SaveModel extends BaseSaveModel {

    /**
     * 
     * @param {GameModel} gameModel 
     * @param {Config} config 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {NGTScenarioPlayer} scenarioPlayer 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(gameModel, config, scenarioLibrary, scenarioPlayer, variableManager) {
        super(config);
        this._gameModel = gameModel;
        this._config = config;
        this._scenarioLibrary = scenarioLibrary;
        this._scenarioPlayer = scenarioPlayer;
        this._variableManager = variableManager;
    }

    _createMinigameSaveGame() {
        const completed = this._gameModel.completed;
        const saveGame = {
            completed: completed,
            elapsedTime: this._gameModel.elapsedTime
        };
        if (!completed && !isNull(this._scenarioLibrary.getCurrentScenario())) {
            saveGame.scenarioId = this._scenarioLibrary.getCurrentScenario().id;
            saveGame.storyMemento = this._scenarioPlayer.getStoryPlayer().save().serialize();
            saveGame.storyVariables = this._variableManager.getState();
            if (!isNull(this._gameModel.currentDialogPlayer)) {
                saveGame.dialogMemento = this._gameModel.currentDialogPlayer.dialogMemento;
            }
        }
        return saveGame;
    }
}
